import FormValidator from "@web/vpt-assets/assets/js/utilities/validations/formValidator";

export default class UserLoginHandler {
    constructor({loginCallback, successLogin}) {
        this.form = document.querySelector('#form-user-login');
        if (!this.form) {
            return;
        }
        this.loginButton = this.form.querySelector('[data-entity="form-user-login-button"]');
        this.loginErrorButton = this.form.querySelector('#login-error-message');
        if (!this.loginButton || !this.loginErrorButton) {
            return;
        }
        this.formValidator = new FormValidator(this.form, {});
        this.loginCallback = loginCallback;
        this.successLogin = successLogin;

        this.eventDelegation();
    };

    eventDelegation() {
        document.querySelectorAll('#form-user-login input').forEach((input) => {
            input.addEventListener('click', () => {
                this.removeDisabled();
            });

            input.addEventListener('input', () => {
                this.removeDisabled();
            });
        });

        this.form.addEventListener('submit', async (e) => {
            e.preventDefault();
            e.stopPropagation();
            if (this.formValidator.validateForm()) {
                const formButton = this.form.querySelector('[data-entity="form-user-login-button"]');
                const responseMsgContainer = document.querySelector('[data-container="form-response-form-user-login"]');
                const loginAnchor = responseMsgContainer.querySelector('[data-open="loginAnchor"]');
                const registerAdvantage = responseMsgContainer.querySelector('[data-entity="register-advantage"]');

                if (formButton) {
                    formButton.disabled = true;
                    formButton.classList.add('disabled');
                }

                const response = await this.loginCallback();
                if (!response.status) return;
                if (response.status === 400 || response.status === 401 || response.status === 402 || response.status === 440) {
                    if (formButton) {
                        formButton.disabled = true;
                        formButton.classList.add('disabled');
                    }

                    if (response.status === 400 || response.status === 402 || response.status === 440) {
                        document.querySelector('[data-container="form-login-user"]').style.display = 'none';
                        responseMsgContainer.querySelector('[data-response-form-title]').innerHTML = response.title;
                        responseMsgContainer.querySelector('[data-response-form-description]').innerHTML = response.message;
                        responseMsgContainer.style.display = '';
                    } else {
                        this.loginErrorButton.style.display = '';
                        this.form.querySelectorAll('input').forEach((input) => {
                            input.classList.add('border-error');
                        });
                    }


                    if (response.status === 440) {
                        document.querySelector('[data-container="form-login-user"]').style.display = 'none';
                        responseMsgContainer.querySelector('[data-response-form-title]').innerHTML = response.title;
                        responseMsgContainer.querySelector('[data-response-form-description]').innerHTML = response.message;
                        responseMsgContainer.style.display = '';

                        if (loginAnchor) {
                            loginAnchor.style.display = 'none';
                        }

                        if (registerAdvantage) {
                            registerAdvantage.style.display = 'none';
                        }
                    } else {
                        if (loginAnchor) {
                            loginAnchor.style.display = '';
                        }

                        if (registerAdvantage) {
                            registerAdvantage.style.display = '';
                        }
                    }
                } else {
                    this.successLogin();
                }
            } else {
                this.loginButton.disabled = false;
                this.loginButton.classList.remove('disabled');
                document.querySelectorAll('#form-user-login input').forEach((input) => {
                    input.classList.add('border-error');
                });
                this.loginErrorButton.style.display = '';
            }
        });
    }

    removeDisabled() {
        this.loginButton.disabled = false;
        this.loginButton.classList.remove('disabled');
        this.loginErrorButton.style.display = 'none';
    }

}
